import { DigitalData } from "@dustin-web/microsite-components/src/utils/digital-data"

export const GaRegEvent = () => {

    const emailGaEvent = () => {
        DigitalData.creatAccountEmail()
    }

    const companyGaEvent = () => {
        DigitalData.creatAccountCompany()
    }

    const companyExistsGaEvent = () => {
        DigitalData.createAccountCompanyExists()
    }

    const companyyRequestOpenGaEvent = () => {
        DigitalData.createAccountCompanyRequestOpen()
    }

    const companyRequestSendGaEvent = () => {
        DigitalData.createAccountCompanyRequestSend()
    }

    const companyRequestConfirmGaEvent = () => {
        DigitalData.createAccountCompanyRequestConfirm()
    }

    const companyCheckoutGaEvent = () => {
        DigitalData.createAccountCompanyCheckout()
    }

    const accountGaEvent = () => {
        DigitalData.creatAccountCreate()
    }

    const completeGaEvent = () => {
        DigitalData.createAccountCompeted()
    }

    const loginRegisterCompleteGaEvent = () => {
        DigitalData.createAccountLoginComplete()
    }

    const loginRegisterEmailGaEvent = () => {
        DigitalData.createAccountLoginEmail()
    }

    const loginRegisterGaEvent = () => {
        DigitalData.createAccountLoginRegister()
    }

    const verifyGaEvent = () => {
        DigitalData.createAccountVerify()
    }

    const registerEmailSucceedGaEvent = () => {
        DigitalData.createAccountEmailSucceed()
    }

    return {
        emailGaEvent,
        companyGaEvent,
        companyExistsGaEvent,
        companyyRequestOpenGaEvent,
        companyRequestSendGaEvent,
        companyRequestConfirmGaEvent,
        companyCheckoutGaEvent,
        accountGaEvent,
        completeGaEvent,
        loginRegisterGaEvent,
        loginRegisterEmailGaEvent,
        loginRegisterCompleteGaEvent,
        verifyGaEvent,
        registerEmailSucceedGaEvent
    }
}
